import type { SalesPartnerStockData } from "~/feature/SalesPartnerStockIntegration/types";
import { resolveApiUrl } from "~/utils/url/urlResolver";

export async function fetchSalesPartnerStock(productCode: string): Promise<SalesPartnerStockData[]> {
  const response = await fetch(resolveApiUrl(`/p/${productCode}/salespartner`), { credentials: "same-origin" });

  if (!response.ok) {
    console.warn(`API call to fetch sales partner stock failed: ${response.status}`);
    return [];
  }

  const data: SalesPartnerStockData[] = await response.json();
  if (!Array.isArray(data)) {
    console.warn(`API call to fetch sales partner stock returned invalid data: ${data}`);
    return [];
  }
  data.forEach((item) => (item.order = Math.random()));

  return data;
}
